export const isDebug = import.meta.env.VITE_DEBUG === 'true' || import.meta.env.MODE === 'development';

export function debugLog(...args: unknown[]): void {
  if (isDebug) {
    console.log(...args);
  }
}

